import React from 'react';
import './embeds.css';

export default function StatCard({ label, value, delta, trendDirection }) {
  return (
    <div className="embed-stat-card">
      <div className="stat-label">{label}</div>
      <div className="stat-value">{value}</div>
      {delta && <div className={`stat-delta ${trendDirection || ''}`}>{delta}</div>}
    </div>
  );
}
